import Vue from 'vue'                         //  加载VUE框架
import App from './App.vue'                   //  模板入口
import router from './router'                 //  路由管理
import store from './store'                   //  状态管理
import {axios} from './utils/request';        //  网络请求库
import i18n from './locales'                  //  国际化

import './core/use'                           //  加载组件库
import './core/lazy_use_element_ui'           //  按需加载 element-ui
import './permission'                         //  路由权限
import dayjs from 'dayjs'                     //  dayjs

Vue.config.productionTip = false

Vue.prototype.$store = store;
Vue.prototype.$http = axios;
Vue.prototype.$dayjs = dayjs;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
